<template>
  <div class="commission_qrcode" style="overflow:hidden !important;">
    <div
      id="mask"
      style="z-index:999;position:fixed;width:100%;height:100%;background:rgba(0,0,0,.8);"
    ></div>

    <div>
      <div id="canvas" style="overflow:hidden !important;">
        <div v-if="canvas">
          <img :src="canvas" />
        </div>
        <div v-else>
          <img
            class="bg_qrcode"
            :style="'height:'+winHeight+'px;'"
            src="/static/img/bg_qrcode.png"
            alt
          />
          <div class>
            <img class="qrcode" :src="qrcode" alt />
          </div>
        </div>
      </div>
      <div class="share_qrcode">
        <!-- <div class="sty_qrcode" @click="share">
        <span class="iconfont icon-logo-wechat"></span>
        <p>分享好友</p>
      </div>
      <div class="sty_qrcode">
        <span class="iconfont icon-xiazai"></span>
        <p>保存图片</p>
        </div>-->
        <!-- <div class="sty_qrcode" @click="share">
        <span class="iconfont icon-logo-wechat"></span>
        <p>分享好友</p>
        </div>-->
        <div class="sty_qrcode" style="width:100%;text-align:center;">
          <span class="iconfont icon-xiazai"></span>
          <p>长按图片保存</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import html2canvas from "html2canvas";

export default {
  name: "commission_qrcode",
  components: {},
  data() {
    return {
      winHeight: document.body.offsetHeight,
      qrcode: "",
      canvas: "",
      link: "",
      show_mask: 0
    };
  },
  created() {
    this.init();
  },
  mounted() {
    window.setTimeout(() => {
      this.posterRead();
    }, 1000);
  },
  methods: {
    init() {
      this.axios({
        url: this.api.member.recommend,
        data: {}
      }).then(res => {
        if (res.error === 0) {
          let p = new Promise((resolve, reject) => {
            this.qrcode = res.qrcode;
            resolve("成功");
          });
          p.then(data => {
            this.share();
          });
        }
      });
    },
    share() {
      this.axios({
        url: this.api.index.shareconfig
      }).then(res => {
        if (res.error === 0) {
          this.wx.wxShare({
            title: "推荐码分享",
            desc: res.shareconfig.desc,
            imgUrl: res.shareconfig.icon,
            link: window.location.href,
            toast: "hide"
          });
        }
      });
    },
    toImg() {
      this.$toast({
        mask: true,
        type: "loading",
        message: "正在生成...",
        duration: 1000
      });

      if (this.canvas) {
        return;
      }
      this.zIndex = -1; // 隐藏canvas截图
      this.canvas_el = document.querySelector("#canvas");

      var width = this.canvas_el.clientWidth;
      var height = this.canvas_el.clientHeight;
      //要将 canvas 的宽高设置成容器宽高的 4 倍
      var scale = 4;
      var canvas = document.createElement("canvas");
      canvas.width = width * scale;
      canvas.height = height * scale;
      canvas.style.width = width + "px";
      canvas.style.height = height + "px";
      var context = canvas.getContext("2d");
      //然后将画布缩放，将图像放大两倍画到画布上
      context.scale(scale, scale);
      html2canvas(this.canvas_el, {
        // useCORS:true,
        allowTaint: true,
        backgroundColor: null,
        scale: 1,
        canvas: canvas
      }).then(canva => {
        let dataURL = canva.toDataURL("image/png");
        this.canvas = dataURL;
        // console.log(this.canvas);
        this.zIndex = 11;
        // this.show_mask = 1;
        document.getElementById("mask").style.display = "none";
      });
    },
    posterRead() {
      // 回调初始化第一屏截图（防止DOM未生成报错）
      let that = this;
      function time() {
        var timer = setTimeout(() => {
          if (document.querySelector("#canvas")) {
            that.toImg();
            window.clearTimeout(timer);
          } else {
            time();
          }
        }, 500);
      }
      time();
    }
  }
};
</script>
<style scoped>
.share_qrcode {
  background-color: white;
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  text-align: center;
}
.sty_qrcode {
  float: left;
  width: 50%;
  font-size: 0.6rem;
  color: #838282;
  padding: 0.25rem 0;
}
.sty_qrcode span {
  color: #45b9bc;
  font-size: 2rem;
}
.bg_qrcode {
  width: 100%;
}
.qrcode {
  position: absolute;
  top: 37%;
  left: 32%;
  width: 7rem;
  height: 7rem;
}
.commission_qrcode {
  position: relative;
}
</style>



// WEBPACK FOOTER //
// src/views/center/recommend/commission_qrcode.vue